import ChartContainer from '../Services/charts/apex-charts/ChartContainer';
import useIndicatorChart from './hooks/useIndicatorChart';

export const Indicator = ({
    title,
    indicatorValue,
    goalValue,
    goalMessage = 'Meta',
    className = '',
    height = 250
}) => {
    const { chartConfig } = useIndicatorChart({
        indicatorValue,
        goalValue,
        goalMessage
    });


    return (
        <ChartContainer
            key={`${title}-${indicatorValue}`}
            title={title}
            options={chartConfig.options}
            series={chartConfig.series}
            height={height}
            type="radialBar"
            className={`${className}`}
        />
    );
};
